var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachineMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2738 21.3667L45.2205 21.3467L43.6338 24.4133L44.6405 29.8333L47.4205 30.8333V24.8934L48.8871 23.1134",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2338 21.3867L61.8005 24.4134L60.7871 29.8334L58.0138 30.8334V24.8934L56.4805 23.04",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8998 22.5933H49.6064",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5198 11.0067L45.0664 5.02002",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6465 7.82007H42.6531L48.9732 13.6867",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6662 2.6333L24.4795 2.64665",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6537 6.33325L24.4803 6.3466H24.4736",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4802 7.84009L15.3668 20.1934L15.3135 20.3001",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2801 5.7666L11.2734 17.9266",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8398 18.5V14.6866C48.8398 14.3333 48.8799 14 48.9732 13.68C49.3132 12.4133 50.2732 11.4 51.5199 11C51.8932 10.88 52.2999 10.8066 52.7199 10.8066C54.8599 10.8066 56.5932 12.5466 56.5932 14.6866V18.5333",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2671 18.7334H49.2471",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6201 48.2933H1V65H20.6201V48.2933Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5262 43.4133H3.09277V48.2933H18.5262V43.4133Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5262 43.4133H3.09277V48.2933H18.5262V43.4133Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37282 26.48H5.97949V43.4133H15.6328V26.48H15.2395",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2402 20.1934H15.3669H19.4336V26.48H15.6336H15.2402",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3732 20.1934H2.18652V26.48H5.97987H6.3732",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86682 53.2466H4.9668",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86682 56.6467H4.9668",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86682 60.0466H4.9668",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6473 53.2466H11.7539",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6473 56.6467H11.7539",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6473 60.0466H11.7539",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2594 32.5735H8.35938",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2594 35.9734H8.35938",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2594 39.3733H8.35938",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8064 28.7734C13.8072 28.7734 16.2397 26.3408 16.2397 23.3401C16.2397 20.3393 13.8072 17.9067 10.8064 17.9067C7.80564 17.9067 5.37305 20.3393 5.37305 23.3401C5.37305 26.3408 7.80564 28.7734 10.8064 28.7734Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 25.6867C12.1027 25.6867 13.1533 24.6361 13.1533 23.34C13.1533 22.044 12.1027 20.9934 10.8066 20.9934C9.5106 20.9934 8.45996 22.044 8.45996 23.34C8.45996 24.6361 9.5106 25.6867 10.8066 25.6867Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5197 7.98668C23.449 7.98668 25.013 6.42267 25.013 4.49335C25.013 2.56403 23.449 1 21.5197 1C19.5904 1 18.0264 2.56403 18.0264 4.49335C18.0264 6.42267 19.5904 7.98668 21.5197 7.98668Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6135 7.98668C43.5428 7.98668 45.1068 6.42267 45.1068 4.49335C45.1068 2.56403 43.5428 1 41.6135 1C39.6841 1 38.1201 2.56403 38.1201 4.49335C38.1201 6.42267 39.6841 7.98668 41.6135 7.98668Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7132 16.6801C53.8105 16.6801 54.6999 15.7907 54.6999 14.6935C54.6999 13.5963 53.8105 12.7068 52.7132 12.7068C51.616 12.7068 50.7266 13.5963 50.7266 14.6935C50.7266 15.7907 51.616 16.6801 52.7132 16.6801Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7739 23.38C49.1877 23.38 50.3339 22.2339 50.3339 20.82C50.3339 19.4062 49.1877 18.26 47.7739 18.26C46.36 18.26 45.2139 19.4062 45.2139 20.82C45.2139 22.2339 46.36 23.38 47.7739 23.38Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7397 23.38C59.1535 23.38 60.2997 22.2339 60.2997 20.82C60.2997 19.4062 59.1535 18.26 57.7397 18.26C56.3258 18.26 55.1797 19.4062 55.1797 20.82C55.1797 22.2339 56.3258 23.38 57.7397 23.38Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2396 48.9533L47.0529 46.0933L43.7463 46.68L41.4929 44.4267L42.0796 41.12L39.2196 39.9333L37.2996 42.6867H34.1129L32.1929 39.9333L29.3329 41.12L29.9196 44.4267L27.6662 46.68L24.3595 46.0933L23.1729 48.9533L25.9262 50.8733V54.06L23.1729 55.98L24.3595 58.84L27.6662 58.2533L29.9196 60.5067L29.3329 63.8134L32.1929 65L34.1129 62.2467H37.2996L39.2196 65L42.0796 63.8134L41.4929 60.5067L43.7463 58.2533L47.0529 58.84L48.2396 55.98L45.4863 54.06V50.8733L48.2396 48.9533ZM32.6996 55.28C32.2662 56.3267 31.0662 56.82 30.0196 56.3867C28.9729 55.9534 28.4795 54.7533 28.9129 53.7067C29.3462 52.66 30.5462 52.1667 31.5929 52.6C32.6396 53.0334 33.1329 54.2334 32.6996 55.28ZM31.7862 46.7867C32.2196 45.74 33.4196 45.2467 34.4662 45.68C35.5129 46.1133 36.0062 47.3134 35.5729 48.36C35.1396 49.4067 33.9396 49.9 32.8929 49.4667C31.8462 49.0333 31.3529 47.8333 31.7862 46.7867ZM36.2062 52.6733C36.0929 52.9467 35.7796 53.08 35.4996 52.9667C35.2262 52.8533 35.0929 52.54 35.2062 52.26C35.3196 51.98 35.6329 51.8533 35.9129 51.9667C36.1862 52.08 36.3196 52.3933 36.2062 52.6733ZM39.6329 58.1534C39.1996 59.2 37.9996 59.6934 36.9529 59.26C35.9062 58.8267 35.4129 57.6267 35.8462 56.58C36.2796 55.5333 37.4796 55.04 38.5263 55.4734C39.5729 55.9067 40.0662 57.1067 39.6329 58.1534ZM42.4996 51.22C42.0663 52.2667 40.8662 52.76 39.8196 52.3267C38.7729 51.8934 38.2796 50.6934 38.7129 49.6467C39.1463 48.6 40.3463 48.1067 41.3929 48.54C42.4396 48.9733 42.9329 50.1734 42.4996 51.22Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0065 58.0466L64.9998 59.6999L63.5998 62.1266L61.1665 61.2266L59.0598 62.4399L58.6265 64.9999H55.8265L55.3931 62.4399L53.2865 61.2266L50.8531 62.1266L49.4531 59.6999L51.4465 58.0466V55.6132L49.4531 53.9599L50.8531 51.5332L53.2865 52.4332L55.3931 51.2199L55.8265 48.6599H58.6265L59.0598 51.2199L61.1665 52.4332L63.5998 51.5332L64.9998 53.9599L63.0065 55.6132V58.0466ZM54.9731 58.1266C55.6931 59.3666 57.2798 59.7932 58.5198 59.0799C59.7598 58.3599 60.1865 56.7732 59.4732 55.5332C58.7532 54.2932 57.1665 53.8665 55.9265 54.5799C54.6865 55.2932 54.2598 56.8866 54.9731 58.1266Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.133 31.7066L48.6997 30.0866L50.5397 29.0266L51.7264 30.2133H53.7064L54.8931 29.0266L56.7331 30.0866L56.2997 31.7066L57.2864 33.4199L58.9064 33.8533V35.9733L57.2864 36.4066L56.2997 38.1199L56.7331 39.74L54.8931 40.7999L53.7064 39.6133H51.7264L50.5397 40.7999L48.6997 39.74L49.133 38.1199L48.1464 36.4066L46.5264 35.9733V33.8533L48.1464 33.4199L49.133 31.7066ZM53.9597 34.9199C53.9597 34.2333 53.3997 33.6733 52.7131 33.6733C52.0264 33.6733 51.4664 34.2333 51.4664 34.9199C51.4664 35.6066 52.0264 36.1666 52.7131 36.1666C53.3997 36.1666 53.9597 35.6066 53.9597 34.9199Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineMobile);
export default __webpack_public_path__ + "static/media/machine_mobile.3df266116f49461114ff1aa199d288a8.svg";
export { ForwardRef as ReactComponent };